import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { TeachersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseTeacherGetProps {
  id: number;
}

export const useTeacherGet = (
  { id }: IUseTeacherGetProps,
  options?: { enabled?: boolean },
) => {
  const accessToken = useAccessToken();

  const { data, isSuccess, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.Teacher, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(TeachersApi, accessToken);
      return service.getTeacherById({
        id,
      });
    },
    enabled: options?.enabled !== false && id > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isSuccess,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
